import MenuOptionsService from "app/services/menuOptions/menuOptions.service";
import {IParentMenuOption} from "shared-components/booking-options-section/ChildMenuOptionOverlay/types";
import {IBookingMenuOptionExtrasUpdater, ITableDate, IBookingMenuOption} from "shared-types/index";

const NS = 'MenuOptionActionService';

class MenuOptionActionService {

  updateActiveChildMenuOption(parentMenuOption: IParentMenuOption) {
    return MenuOptionsService.updateActiveChildMenuOption(parentMenuOption);
  }

  updateCachedMenuOptionDetails(ids: string[], fullRefresh = false) {
    MenuOptionsService.updateCachedMenuOptionDetails(ids, fullRefresh);
  }

  updateMenuOptionExtras(data: IBookingMenuOptionExtrasUpdater, serviceId: string, bookingDate: Date, bookingTimes: ITableDate[]) {
   return MenuOptionsService.updateMenuOptionExtras(data, serviceId, bookingDate, bookingTimes);
  }

  updateSelectedMenuOption(selectedMenuOptions: IBookingMenuOption[], isUpsell= false) {
    if (isUpsell) {
      return MenuOptionsService.updateSelectedUpsellMenuOption(selectedMenuOptions);
    }
    return MenuOptionsService.updateSelectedMenuOption(selectedMenuOptions);
  }
}

// singleton
const instance = new MenuOptionActionService();
export default instance;
